import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import { CartProvider } from './context/CartContext';
import { ProductProvider } from './context/ProductContext';
import { FloatingControls } from './components/FloatingControls';
import { CartDrawer } from './components/CartDrawer';

// Pages
import { Home } from './pages/Home';
import { Shop } from './pages/Shop';
import { OurStory } from './pages/OurStory';
import { Journal } from './pages/Journal';
import { Contact } from './pages/Contact';
import { ProductDetail } from './pages/ProductDetail';
import { ServiceDetail } from './pages/ServiceDetail';
import { TrackOrder } from './pages/TrackOrder';

function App() {
  return (
    <Router>
      <ProductProvider>
        <CartProvider>
          <ScrollToTop />
          <FloatingControls />
          <CartDrawer />
          <div className="font-body text-simba-dark bg-simba-cream min-h-screen flex flex-col">
            <Navbar />
            <main className="flex-grow">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/shop" element={<Shop />} />
                <Route path="/product/:slug" element={<ProductDetail />} />
                <Route path="/services/:id" element={<ServiceDetail />} />
                <Route path="/our-story" element={<OurStory />} />
                <Route path="/journal" element={<Journal />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/track-order" element={<TrackOrder />} />
              </Routes>
            </main>
            <Footer />
          </div>
        </CartProvider>
      </ProductProvider>
    </Router>
  );
}

export default App;
